import { motion } from 'framer-motion';
import RunawayButton from '../components/RunawayButton';
import '../styles/templates.css';

const FloatingPopcorn = () => (
  <div className="floating-popcorn">
    {[...Array(12)].map((_, i) => (
      <motion.div
        key={i}
        className="popcorn"
        style={{
          left: `${Math.random() * 100}%`,
          top: `${Math.random() * 100}%`,
        }}
        animate={{
          y: [0, -20, 0],
          rotate: [0, 10, -10, 0],
          opacity: [0.6, 1, 0.6],
        }}
        transition={{
          duration: 3 + Math.random() * 2,
          repeat: Infinity,
          delay: Math.random() * 2,
        }}
      >
        {['\uD83C\uDF7F', '\uD83C\uDFAC', '\uD83C\uDFA5', '\uD83C\uDF9E\uFE0F'][Math.floor(Math.random() * 4)]}
      </motion.div>
    ))}
  </div>
);

const MovieNightTemplate = ({ question, onYes, showCta, cta, patternStyle = {} }) => {
  if (showCta) {
    return (
      <motion.div
        className="template movie-template cta-view"
        initial={{ rotateY: 90 }}
        animate={{ rotateY: 0 }}
        transition={{ duration: 0.6 }}
      >
        <div className="pattern-overlay" style={patternStyle} />
        <FloatingPopcorn />
        <div className="cta-content">
          <motion.div
            className="success-icon"
            animate={{ scale: [1, 1.2, 1], rotate: [0, 5, -5, 0] }}
            transition={{ duration: 0.5, repeat: Infinity, repeatDelay: 1 }}
          >
            {'\uD83C\uDFAC'}
          </motion.div>
          <h1>It's Movie Time!</h1>
          <p className="cta-text">{cta}</p>
          <motion.div
            className="confetti"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            {'\uD83C\uDF7F\uD83C\uDFA5\uD83C\uDF9E\uFE0F\uD83C\uDFA5\uD83C\uDF7F'}
          </motion.div>
        </div>
      </motion.div>
    );
  }

  return (
    <div className="template movie-template">
      <div className="pattern-overlay" style={patternStyle} />
      <FloatingPopcorn />
      <div className="template-content">
        <motion.div
          className="movie-icon"
          animate={{ y: [0, -10, 0] }}
          transition={{ duration: 2, repeat: Infinity }}
        >
          {'\uD83C\uDFAC'}
        </motion.div>

        <motion.h1
          className="invite-question"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.3 }}
        >
          {question}
        </motion.h1>

        <div className="button-container">
          <motion.button
            className="yes-button movie-yes"
            onClick={onYes}
            whileHover={{ scale: 1.1 }}
            whileTap={{ scale: 0.95 }}
          >
            Yes! {'\uD83C\uDF7F'}
          </motion.button>
        </div>
      </div>

      <RunawayButton className="movie-no">
        Maybe later...
      </RunawayButton>
    </div>
  );
};

export default MovieNightTemplate;
